module.exports = __webpack_public_path__ + "img/fraise.92e891f7.jpg";